(function(){
if(window.__bqp) return; window.__bqp=1;
if(!document.querySelector('.shopify-section.bqp:not(.shopify-section-group-footer-group)')) return;
function bqRun(){

  // thema-editor: alles direct zichtbaar
  try{ if(window.Shopify&&Shopify.designMode){ document.documentElement.classList.add('bq-design'); }
    document.addEventListener('shopify:section:load',function(ev){ ev.target.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');}); });
  }catch(e){}

try{
  // announcement bar, één melding tegelijk
  var slides = document.querySelectorAll('#annSlides .slide');
  var idx = 0, timer;
  function show(n){
    slides[idx].classList.remove('is-on');
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add('is-on');
  }
  function start(){ timer = setInterval(function(){ show(idx + 1); }, 4000); }
  function restart(){ clearInterval(timer); start(); }
  document.getElementById('annNext').addEventListener('click', function(){ show(idx + 1); restart(); });
  document.getElementById('annPrev').addEventListener('click', function(){ show(idx - 1); restart(); });
  start();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // mobiel menu

}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // reviews: doorlopend, na de laatste komt de eerste weer
  (function(){
    var row=document.getElementById('rvRow'); if(!row) return;
    var originals=[].slice.call(row.children);
    var n=originals.length;
    function clone(el){ var c=el.cloneNode(true); c.setAttribute('aria-hidden','true'); c.querySelectorAll('a,button').forEach(function(x){x.setAttribute('tabindex','-1');}); if(c.tagName==='A') c.setAttribute('tabindex','-1'); return c; }
    originals.forEach(function(el){ row.appendChild(clone(el)); });
    originals.slice().reverse().forEach(function(el){ row.insertBefore(clone(el), row.firstChild); });
    function setWidth(){ var a=row.children[n], b=row.children[2*n]; return b.offsetLeft - a.offsetLeft; }
    function jumpTo(x){ row.style.scrollBehavior='auto'; row.style.scrollSnapType='none'; row.scrollLeft=x; row.offsetHeight; row.style.scrollSnapType=''; row.style.scrollBehavior=''; }
    function toStart(){ jumpTo(row.children[n].offsetLeft - row.children[0].offsetLeft); }
    toStart();
    window.addEventListener('resize', toStart);
    var t;
    row.addEventListener('scroll', function(){
      clearTimeout(t);
      t=setTimeout(function(){
        var w=setWidth(), start=row.children[n].offsetLeft-row.children[0].offsetLeft;
        if(row.scrollLeft < start - w*0.5) jumpTo(row.scrollLeft + w);
        else if(row.scrollLeft > start + w*0.5) jumpTo(row.scrollLeft - w);
      },140);
    },{passive:true});
    function step(d){ var c=row.children[n]; var gap=parseFloat(getComputedStyle(row).columnGap)||16; row.scrollBy({left:d*(c.getBoundingClientRect().width+gap),behavior:'smooth'}); }
    document.getElementById('rvPrev').addEventListener('click',function(){step(-1);});
    document.getElementById('rvNext').addEventListener('click',function(){step(1);});
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // zeven modi: rail met pijltjes en voortgangsbalk
  (function(){
    var rail=document.getElementById('mRail'); if(!rail) return;
    var bar=document.getElementById('mBar');
    function update(){ var max=rail.scrollWidth-rail.clientWidth; var r=max>0?rail.scrollLeft/max:1; var min=rail.clientWidth/rail.scrollWidth; bar.style.width=Math.round((min+(1-min)*r)*100)+'%'; }
    function step(d){ var c=rail.querySelector('.m-card'); rail.scrollBy({left:d*(c.getBoundingClientRect().width+16),behavior:'smooth'}); }
    rail.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',update);
    document.getElementById('mPrev').addEventListener('click',function(){step(-1);});
    document.getElementById('mNext').addEventListener('click',function(){step(1);});
    update();
  })();



}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // productgalerij: thumbnails, pijlen, swipen
  (function(){
    var track=document.getElementById('pdpTrack'); if(!track) return;
    var slides=track.querySelectorAll('.pdp-slide');
    var thumbs=document.querySelectorAll('#pdpThumbs button');
    function cur(){ return Math.round(track.scrollLeft/track.clientWidth); }
    function go(i){ i=(i+slides.length)%slides.length; track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
    var strip=document.getElementById('pdpThumbs'), lastI=-1;
    function follow(el,box){ if(!el||!box) return; var target=el.offsetLeft-(box.clientWidth-el.offsetWidth)/2; box.scrollTo({left:Math.max(0,target),behavior:'smooth'}); }
    function sync(){ var i=cur(); thumbs.forEach(function(t,k){ t.classList.toggle('is-on',k===i); }); if(i!==lastI){ lastI=i; follow(thumbs[i],strip); } }
    track.addEventListener('scroll',function(){ window.requestAnimationFrame(sync); },{passive:true});
    thumbs.forEach(function(t,k){ t.addEventListener('click',function(){ go(k); }); });
    document.getElementById('pdpPrev').addEventListener('click',function(){ go(cur()-1); });
    document.getElementById('pdpNext').addEventListener('click',function(){ go(cur()+1); });
    track.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){e.preventDefault();go(cur()+1);} if(e.key==='ArrowLeft'){e.preventDefault();go(cur()-1);} });
  })();



}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // hoofdfoto met de muis te slepen, zoals swipen op mobiel
  (function(){
    var main=document.querySelector('.pdp-main'), track=document.getElementById('pdpTrack');
    if(!main||!track) return;
    var down=false,startX=0,startL=0,moved=false;
    track.addEventListener('mousedown',function(e){ down=true;moved=false;main.dataset.moved='';startX=e.pageX;startL=track.scrollLeft;main.classList.add('dragging'); e.preventDefault(); });
    window.addEventListener('mousemove',function(e){ if(!down) return; var dx=e.pageX-startX; if(Math.abs(dx)>3){ moved=true; main.dataset.moved='1'; } track.scrollLeft=startL-dx; });
    window.addEventListener('mouseup',function(){
      if(!down) return; down=false; main.classList.remove('dragging');
      var w=track.clientWidth, i=Math.round(track.scrollLeft/w);
      var d=track.scrollLeft-startL; if(Math.abs(d)>w*0.12 && i===Math.round(startL/w)) i+= d>0?1:-1;
      i=Math.max(0,Math.min(i,track.children.length-1));
      track.scrollTo({left:i*w,behavior:'smooth'});
    });
  })();



}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // ingezoomde weergave vullen met dezelfde foto's als de galerij
  (function(){
    var pt=document.getElementById('pdpTrack'), lt=document.getElementById('lbTrack'), ld=document.getElementById('lbDots');
    if(!pt||!lt||!ld) return;
    [].forEach.call(pt.querySelectorAll('img'),function(img,i){
      var sl=document.createElement('div'); sl.className='lb-slide';
      var big=document.createElement('img'); big.src=(function(m){var s=m.getAttribute('src')||m.getAttribute('data-src');if(s)return s;var p=(m.getAttribute('data-srcset')||m.getAttribute('srcset')||'').split(',').map(function(x){return x.trim().split(' ')[0];}).filter(Boolean);return p[Math.min(3,p.length-1)]||'';})(img); big.alt=img.alt||''; big.loading='lazy';
      sl.appendChild(big); lt.appendChild(sl);
      var th=document.querySelectorAll('#pdpThumbs img')[i];
      var d=document.createElement('button'); d.type='button'; d.setAttribute('aria-label','Show image '+(i+1));
      if(i===0) d.className='is-on';
      var ti=document.createElement('img'); ti.src=(th?th.src:img.src); ti.alt='';
      d.appendChild(ti); ld.appendChild(d);
    });
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // ingezoomde weergave: klik op de foto, bolletjes eronder, doorscrollen
  (function(){
    var lb=document.getElementById('lb'), lt=document.getElementById('lbTrack'), main=document.querySelector('.pdp-main'), pt=document.getElementById('pdpTrack');
    if(!lb||!lt||!pt) return;
    var dots=document.querySelectorAll('#lbDots button'), n=lt.children.length, lastFocus=null;
    function cur(){ return Math.round(lt.scrollLeft/lt.clientWidth); }
    function go(i,instant){ i=(i+n)%n; lt.scrollTo({left:i*lt.clientWidth,behavior:instant?'auto':'smooth'}); }
    function sync(){ var i=cur(); dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); var d=dots[i], box=document.getElementById('lbDots'); if(d&&box){ box.scrollTo({left:Math.max(0,d.offsetLeft-(box.clientWidth-d.offsetWidth)/2),behavior:'smooth'}); } }
    function open(i){
      lastFocus=document.activeElement;
      lb.classList.add('open'); lb.setAttribute('aria-hidden','false'); document.body.classList.add('lb-lock');
      lt.style.scrollBehavior='auto'; lt.scrollLeft=i*lt.clientWidth; lt.style.scrollBehavior='';
      sync(); document.getElementById('lbClose').focus();
    }
    function close(){
      var i=cur();
      lb.classList.remove('open'); lb.setAttribute('aria-hidden','true'); document.body.classList.remove('lb-lock');
      pt.style.scrollBehavior='auto'; pt.scrollLeft=i*pt.clientWidth; pt.style.scrollBehavior='';
      if(lastFocus) lastFocus.focus();
    }
    pt.addEventListener('click',function(){ if(main.dataset.moved==='1'){ main.dataset.moved=''; return; } open(Math.round(pt.scrollLeft/pt.clientWidth)); });
    pt.addEventListener('keydown',function(e){ if(e.key==='Enter'){ open(Math.round(pt.scrollLeft/pt.clientWidth)); } });
    lt.addEventListener('scroll',function(){ window.requestAnimationFrame(sync); },{passive:true});
    document.getElementById('lbPrev').addEventListener('click',function(){ go(cur()-1); });
    document.getElementById('lbNext').addEventListener('click',function(){ go(cur()+1); });
    document.getElementById('lbClose').addEventListener('click',close);
    dots.forEach(function(d,k){ d.addEventListener('click',function(){ go(k); }); });
    document.addEventListener('keydown',function(e){
      if(!lb.classList.contains('open')) return;
      if(e.key==='Escape') close();
      if(e.key==='ArrowRight') go(cur()+1);
      if(e.key==='ArrowLeft') go(cur()-1);
    });
    window.addEventListener('resize',function(){ if(lb.classList.contains('open')) go(cur(),true); });
  })();




}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // levertijden, altijd vanaf vandaag: verzonden de dag erna, bezorgd 3 tot 5 dagen na bestelling
  (function(){
    var fmt=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric'});
    function addBusinessDays(from,n){ var d=new Date(from); while(n>0){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) n--; } return d; }
    var today=new Date();
    function addDays(n){ var d=new Date(today); d.setDate(d.getDate()+n); return d; }
    var et=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'})); var wd=et.getDay(); var sent=(wd>0&&wd<6&&et.getHours()<12)?new Date(today):addBusinessDays(today,1); var from=new Date(Math.max(today.getTime()+2*864e5, sent.getTime()+864e5)), to=new Date(today.getTime()+5*864e5);
    document.getElementById('tlOrdered').textContent=fmt.format(today);
    document.getElementById('tlSent').textContent=fmt.format(sent);
    document.getElementById('tlDelivered').textContent = from.getMonth()===to.getMonth() ? fmt.format(from)+'-'+to.getDate() : fmt.format(from)+' - '+fmt.format(to);
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // bundelkeuze zoals Aersoak: kaart kiezen, prijs in de knop en de vaste koopbalk
  (function(){
    var cards=document.querySelectorAll('.bcard');
    function pick(card){
      cards.forEach(function(c){ c.classList.toggle('is-selected',c===card); });
      var inp=card.querySelector('input'); inp.checked=true;
      document.getElementById('buyPrice').textContent=inp.dataset.price;
      document.getElementById('bbPrice').textContent=inp.dataset.price;
      document.getElementById('bbSel').textContent=inp.dataset.name;
      if(inp.dataset.img) document.getElementById('bbImg').src=inp.dataset.img;
      document.getElementById('ppNow').textContent=inp.dataset.price; document.getElementById('ppWas').textContent=inp.dataset.was; document.getElementById('ppSave').textContent=inp.dataset.save;
    }
    cards.forEach(function(c){ c.querySelector('input').addEventListener('change',function(){ pick(c); }); });
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // vaste koopbalk zodra de koopknop uit beeld is (niet bij de footer)
  (function(){
    var bar=document.getElementById('buybar'), btnBuy=document.getElementById('buyBtn'), foot=document.querySelector('footer');var pr=document.querySelector('.pdp-price'); if(pr&&!document.querySelector('.pdp-trust')){ var tr=document.createElement('p'); tr.className='pdp-trust'; tr.textContent='✓ 30-day money-back guarantee · Free US shipping'; pr.insertAdjacentElement('afterend',tr); } var one=parseFloat(((document.querySelector('.bcard input[value="1"]')||{}).dataset||{price:'0'}).price.replace(/[^0-9.]/g,'')); document.querySelectorAll('.bcard input').forEach(function(i){ var q=+i.value; if(q>1&&one){ var p=parseFloat(i.dataset.price.replace(/[^0-9.]/g,'')); var sv=document.createElement('span'); sv.className='bc-saving'; sv.textContent='Save $'+(one*q-p).toFixed(2); var w=i.closest('.bcard').querySelector('.bc-was'); if(w) w.insertAdjacentElement('afterend',sv); } }); var bb=document.getElementById('buyBtn'); if(bb){ var sh=document.createElement('p'); sh.className='pdp-ship'; bb.insertAdjacentElement('afterend',sh); var tick=function(){ var e2=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'})); var md=new Date(e2.getTime()); md.setHours(24,0,0,0); var r2=md-e2, wd2=e2.getDay(); if(wd2==5&&e2.getHours()<12){var nn=new Date(e2.getTime()); nn.setHours(12,0,0,0); var r3=nn-e2; sh.innerHTML='Order within <b>'+Math.floor(r3/3600000)+'h '+Math.floor((r3%3600000)/60000)+'m</b> · ships today'; return;} if(wd2==5||wd2==6||wd2==0){var mo=new Date(e2.getTime()); mo.setDate(mo.getDate()+(8-wd2)%7); mo.setHours(12,0,0,0); var r4=mo-e2; sh.innerHTML='Order within <b>'+Math.floor(r4/86400000)+'d '+Math.floor((r4%86400000)/3600000)+'h '+Math.floor((r4%3600000)/60000)+'m</b> · ships Monday'; return; sh.innerHTML='Order now · <b>ships Monday</b>'; return;} sh.innerHTML='Order within <b>'+Math.floor(r2/3600000)+'h '+Math.floor((r2%3600000)/60000)+'m</b> · ships within 24 hours'; return; var et=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'})); var d=et.getDay(); var cut=new Date(et.getTime()); cut.setHours(12,0,0,0); var ms=cut-et; if(d>0&&d<6&&ms>0){ var h=Math.floor(ms/3600000), m=Math.floor((ms%3600000)/60000); sh.innerHTML='Order within <b>'+h+'h '+m+'m</b> for same-day dispatch'; } else { sh.textContent='Order now, ships next business day'; } }; tick(); setInterval(tick,30000);}
    function upd(){
      var r=btnBuy.getBoundingClientRect(), mob=window.innerWidth<900, past=mob?!(r.top<window.innerHeight&&r.bottom>0):r.bottom<0;
      var atFoot=foot.getBoundingClientRect().top<window.innerHeight;
      var on=past&&!atFoot;
      bar.classList.toggle('is-on',on);
      bar.setAttribute('aria-hidden',on?'false':'true');
      bar.querySelector('.bb-add').setAttribute('tabindex',on?'0':'-1');
    }
    window.addEventListener('scroll',upd,{passive:true}); upd();
  })();

  var btn = document.getElementById('menuBtn');
  var nav = document.getElementById('mobileNav');
  btn.addEventListener('click', function () {
    var open = nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (typeof headerState === 'function') headerState();
  });
  nav.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') { nav.classList.remove('open'); btn.setAttribute('aria-expanded','false'); if (typeof headerState === 'function') headerState(); }
  });



}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // header: transparant over de hero, wit zodra je scrolt of het menu opent
  var siteHeader = document.getElementById('siteHeader');
  function headerState(){
    var menuOpen = document.getElementById('mobileNav').classList.contains('open');
    var heroEl = document.querySelector('.hero');
    siteHeader.classList.add('solid');
  }
  window.addEventListener('scroll', headerState, { passive:true });
  headerState();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // zeven modi: het beeld volgt de modus die in beeld is
  (function(){
    var modes = document.querySelectorAll('.mode');
    var frames = document.querySelectorAll('.modes-visual .frame');
    var mvNum = document.getElementById('mvNum');
    var mvName = document.getElementById('mvName');
    if (!modes.length) return;
    function activate(i){
      modes.forEach(function(m){ m.classList.toggle('is-active', +m.getAttribute('data-i') === i); });
      frames.forEach(function(f){ f.style.opacity = (+f.getAttribute('data-mode') === i) ? '1' : '0'; });
      mvNum.innerHTML = String(i + 1).padStart(2,'0') + '<span>/07</span>';
      mvName.textContent = modes[i].querySelector('h3').textContent;
    }
    if ('IntersectionObserver' in window) {
      var mo = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) activate(+en.target.getAttribute('data-i')); });
      }, { rootMargin:'-45% 0px -45% 0px' });
      modes.forEach(function(m){ mo.observe(m); });
    }
    modes.forEach(function(m){ m.addEventListener('mouseenter', function(){ activate(+m.getAttribute('data-i')); }); });
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // productfoto's: swipen, pijltjes en bolletjes
  (function(){
    var track=document.getElementById('gTrack');
    if(!track) return;
    var slides=track.querySelectorAll('.g-slide');
    var dots=document.querySelectorAll('#gDots .g-dot');
    function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i){ i=(i+slides.length)%slides.length; track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
    function sync(){ var i=current(); dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); }
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, {passive:true});
    document.getElementById('gPrev').addEventListener('click', function(){ go(current()-1); });
    document.getElementById('gNext').addEventListener('click', function(){ go(current()+1); });
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); }); });
    track.addEventListener('keydown', function(e){
      if(e.key==='ArrowRight'){ e.preventDefault(); go(current()+1); }
      if(e.key==='ArrowLeft'){ e.preventDefault(); go(current()-1); }
    });
  })();




}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // rustige fade-in bij scrollen
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

}catch(e){ if(window.console) console.warn("bq",e); }


  // bundel: begin met de aangevinkte kaart
  try{(function(){
    var ch=document.querySelector('.bcard input:checked'); if(!ch) return;
    ch.dispatchEvent(new Event('change'));
  })();}catch(e){}
  // in winkelmandje: product + aantal uit de bundel, korting via Section Store
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-bq-add]'); if(!a) return;
    e.preventDefault();
    var inp=document.querySelector('.bset input:checked'); var q=inp?parseInt(inp.value,10)||1:1;
    var id=a.getAttribute('data-variant'); if(!id) return;
    a.setAttribute('aria-busy','true');
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:q}]})})
      .then(function(r){ if(!r.ok) throw new Error('add'); window.location.href=root+'cart'; })
      .catch(function(){ window.location.href=root+'cart/add?id='+id+'&quantity='+q; });
  });

}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",bqRun); else bqRun();
})();
